export const types = {
  SELECT_PATIENT: 'SELECT_PATIENT',
  SELECT_SCREEN: 'SELECT_SCREEN'
};

export default {
  types
};
